import React from "react";

const Icon = ({
  size = 20,
  name,
  id = "",
  color = "white",
  disabled = false,
  onClick = () => {},
  pointer = false,
  className = "",
}) => {
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick(e);
  };

  const useCurrentColor = color === "current" || color === "currentColor";
  const style = useCurrentColor
    ? { fontSize: size, color: "currentColor" }
    : { fontSize: size };
  const colorClass = useCurrentColor ? "" : `text-${color}`;

  return (
    <i
      data-testid={id}
      style={style}
      onClick={handleClick}
      className={`icon ${colorClass} ${
        pointer && !disabled ? "cursor-pointer" : ""
      } isax isax-${name} ${disabled ? "text-opacity-50" : ""} ${className}`}
    ></i>
  );
};

export default Icon;
